import {
    AvatarQuality,
    StreamingEvents,
    VoiceChatTransport,
    VoiceEmotion,
    StartAvatarRequest,
    STTProvider,
    ElevenLabsModel,
    StreamingTalkingMessageEvent,
    UserTalkingMessageEvent,
} from "@heygen/streaming-avatar";
import { useEffect, useRef, useState } from "react";

import { Button } from "@/shared/ui/Button";
import { AvatarConfig } from "./AvatarConfig";
// import { AvatarVideo } from "./AvatarSession/AvatarVideo";
// import { useStreamingAvatarSession } from "./logic/useStreamingAvatarSession";
// import { AvatarControls } from "./AvatarSession/AvatarControls";
// import { useVoiceChat } from "./logic/useVoiceChat";
// import { StreamingAvatarProvider, StreamingAvatarSessionState } from "./logic";
import { LoadingIcon } from "@/shared/ui/Icon/icons";
// import { MessageHistory } from "./AvatarSession/MessageHistory";

import { AVATARS } from "@/shared/const/avatar";
import { StreamingAvatarStoreProvider } from "@/features/avatar/store/context";
import { useStreamingAvatarStore } from "@/features/avatar/lib/useStreamingAvatarStore";
import { StreamingAvatarSessionState } from "@/features/avatar/const";
import { observer } from "mobx-react-lite";
import { AvatarControls } from "@/widgets/AvatarSideBar/ui/AvatarStreaming/ui/AvatarControls";
import { AvatarVideo } from "@/widgets/AvatarSideBar/ui/AvatarStreaming/ui/AvatarVideo";

const DEFAULT_CONFIG: StartAvatarRequest = {
    quality: AvatarQuality.Low,
    avatarName: AVATARS[0].avatar_id,
    knowledgeId: undefined,
    voice: {
        rate: 1.5,
        emotion: VoiceEmotion.EXCITED,
        model: ElevenLabsModel.eleven_flash_v2_5,
    },
    language: "en",
    voiceChatTransport: VoiceChatTransport.WEBSOCKET,
    sttSettings: {
        provider: STTProvider.DEEPGRAM,
    },
};

export const InteractiveAvatar = observer(() => {
    const avatarStore = useStreamingAvatarStore();
    // const { startVoiceChat } = useVoiceChat();

    const [config, setConfig] = useState<StartAvatarRequest>(DEFAULT_CONFIG);

    const mediaStream = useRef<HTMLVideoElement>(null);

    async function createSessionToken() {
        try {
            const response = await fetch(
                "https://api.heygen.com/v1/streaming.create_token",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key":
                            "YjFjYjU0MWExNDY0NDU5MmI5NDI3NmQ0NjQxNjY4NTAtMTczOTYzMzk5MQ==",
                    },
                },
            );
            const { data } = await response.json();
            console.log("Access Token:", data);
            return data.token; // Log the token to verify
        } catch (error) {
            console.error("Error fetching access token:", error);
            throw error;
        }
    }

    const startSessionV2 = async (isVoiceChat: boolean) => {
        try {
            const newToken = await createSessionToken();
            const avatar = avatarStore.init(newToken);

            avatar.on(
                StreamingEvents.AVATAR_START_TALKING,
                (e: StreamingTalkingMessageEvent) => {
                    console.log("Avatar started talking", e);
                },
            );
            avatar.on(
                StreamingEvents.AVATAR_STOP_TALKING,
                (e: StreamingTalkingMessageEvent) => {
                    console.log("Avatar stopped talking", e);
                },
            );
            avatar.on(StreamingEvents.STREAM_DISCONNECTED, () => {
                console.log("Stream disconnected");
            });
            avatar.on(
                StreamingEvents.STREAM_READY,
                (event: { detail: string }) => {
                    console.log(">>>>> Stream ready:", event.detail);
                },
            );
            avatar.on(
                StreamingEvents.USER_START,
                (event: StreamingTalkingMessageEvent) => {
                    console.log(">>>>> User started talking:", event);
                },
            );
            avatar.on(
                StreamingEvents.USER_STOP,
                (event: { detail: string }) => {
                    console.log(">>>>> User stopped talking:", event);
                },
            );
            avatar.on(
                StreamingEvents.USER_END_MESSAGE,
                (event: UserTalkingMessageEvent) => {
                    console.log(">>>>> User end message:", event);
                },
            );
            avatar.on(
                StreamingEvents.USER_TALKING_MESSAGE,
                (event: UserTalkingMessageEvent) => {
                    console.log(">>>>> User talking message:", event);
                },
            );
            avatar.on(
                StreamingEvents.AVATAR_TALKING_MESSAGE,
                (event: UserTalkingMessageEvent) => {
                    console.log(">>>>> Avatar talking message:", event);
                },
            );
            avatar.on(
                StreamingEvents.AVATAR_END_MESSAGE,
                (event: UserTalkingMessageEvent) => {
                    console.log(">>>>> Avatar end message:", event);
                },
            );

            await avatarStore.start(config);

            // if (isVoiceChat) {
            //     await startVoiceChat();
            // }
        } catch (error) {
            console.error("Error starting avatar session:", error);
        }
    };

    useEffect(() => {
        return () => {
            avatarStore.stop();
        };
    }, []);

    useEffect(() => {
        if (avatarStore.stream && mediaStream.current) {
            mediaStream.current.srcObject = avatarStore.stream;
            mediaStream.current.onloadedmetadata = () => {
                mediaStream.current!.play();
            };
        }
    }, [mediaStream, avatarStore.stream]);

    return (
        <div className="w-full flex flex-col gap-4">
            <div className="flex flex-col rounded-xl bg-zinc-900 overflow-hidden">
                <div className="relative w-full aspect-video overflow-hidden flex flex-col items-center justify-center">
                    {avatarStore.sessionState !==
                    StreamingAvatarSessionState.INACTIVE ? (
                        <AvatarVideo ref={mediaStream} />
                    ) : (
                        <AvatarConfig
                            config={config}
                            onConfigChange={setConfig}
                        />
                    )}
                </div>
                <div className="flex flex-col gap-3 items-center justify-center p-4 border-t border-zinc-700 w-full">
                    {avatarStore.sessionState ===
                    StreamingAvatarSessionState.CONNECTED ? (
                        <AvatarControls />
                    ) : avatarStore.sessionState ===
                      StreamingAvatarSessionState.INACTIVE ? (
                        <div className="flex flex-row gap-4">
                            {/*<Button onClick={() => startSessionV2(true)}>*/}
                            {/*    Start Voice Chat*/}
                            {/*</Button>*/}
                            <Button onClick={() => startSessionV2(false)}>
                                Start Text Chat
                            </Button>
                        </div>
                    ) : (
                        <LoadingIcon />
                    )}
                </div>
            </div>
            {avatarStore.sessionState ===
                StreamingAvatarSessionState.CONNECTED && (
                <div>MessageHistory</div> // <MessageHistory />
            )}
        </div>
    );
});
